import React from 'react';
import Store from '../shared/state/Store';
import ConfigReducer from '../shared/state/ConfigReducer';
import ModellerReducer from '../modeller/ModellerReducer';
import { convertLegacyGraphics } from '../modeller/ModelPreview/cytoscape/GraphicsConverter';

export default ({ children }) => {
  const [globalState, dispatch] = Store.useStore();
  React.useEffect(() => {
    dispatch(ConfigReducer.mapOutputConfig());
  }, [globalState.config?.outputConfig]);

  React.useEffect(() => {
    if (globalState.config?.model) {
      dispatch(ModellerReducer.loadModel(convertLegacyGraphics(globalState.config?.model)));
    }
  }, [globalState.config?.model]);

  return (
    <>
      {children}
    </>
  );
};
